﻿<script setup>
    defineProps({
        title: String
    })
</script>
<template>
    <q-page-sticky expand position="top" z-10>
        <q-toolbar bg-zinc-100 drop-shadow select-none drop-shadow-md class="page-header">
            <q-toolbar-title text-blue-800 font-semibold text-base>
                {{title}}
                <q-tooltip anchor="top middle" self="center left" :offset="[150, 10]" :hide-delay="2000" class="xs">
                    {{title}}
                </q-tooltip>
            </q-toolbar-title>
            <slot></slot>
        </q-toolbar>
    </q-page-sticky>
</template>

<style lang="scss">
    .page-header {
        .q-btn,
        .q-separator {
            margin-left: 0.75rem;
        }
    }
</style>